import { Injectable } from "@angular/core";
import { Apollo, QueryRef } from "apollo-angular";
import { TaskServiceInterface } from "./definitions/task-service-interface";
import taskByIdQuery from "./queries/task-by-id";
import { ErrorsInterface } from "../errors/errors-interface";

interface TaskByIdResponse {
  task: {
    byId: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TaskByIdService {
  constructor(private apollo: Apollo) {}

  getTaskById(taskId): QueryRef<TaskByIdResponse> {
    return this.apollo.watchQuery<TaskByIdResponse>({
      query: taskByIdQuery,
      variables: {
        id: taskId,
      },
      pollInterval: 15000,
      fetchPolicy: "network-only",
    });
  }
}
